var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoubleMailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.316l5.797 2.877a.425.425 0 00.377 0l5.797-2.876v4.996c0 .431-.173.846-.483 1.159-.31.313-.734.501-1.185.526l-.1.002H1.768c-.451 0-.886-.165-1.214-.46a1.655 1.655 0 01-.551-1.131L0 12.313V7.316zm1.768-2.66l7.534.975c.451 0 1.787-.81 2.115-.514.329.296.526.7.552 1.13l.002.096v.096l-5.985 2.97L0 6.438v-.096c0-.43.173-.845.483-1.158.31-.314.734-.502 1.185-.526l.1-.003z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.428 2.66l5.797 2.876a.424.424 0 00.377 0l5.797-2.876v4.997c0 .43-.173.845-.483 1.159-.31.313-.734.501-1.185.525l-.1.003-7.755-.042c0-.43-1.14-.439-1.47-.735-.327-.296-.95-.384-.976-.815l-.002-.095V2.66zM5.196 0h8.434c.452 0 .887.165 1.215.46.328.297.526.701.551 1.132l.003.095v.096L9.413 4.752l-5.985-2.97v-.095c0-.43.173-.845.483-1.159.31-.313.734-.501 1.185-.525l.1-.003z",
    fill: "#fff"
  })));
}

export default SvgDoubleMailIcon;